module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/music-c51fb8ef8550c94deabcfce95376cb98.svg";